export const BIOMETRIC_CONSENT_TITLE = 'Verify Your Identity';

const BIOMETRIC_CONSENT_INCODE_PROVIDERS_URL = 'https://incode.com/biometric-data-policy-and-notice';
export const BIOMETRIC_CONSENT_PRIVACY_POLICY_URL = 'https://www.evidentid.com/privacy-policy/';

export const BIOMETRIC_CONSENT_CHECKBOX_LABEL = 'I provide my explicit, opt-in consent to the collection, processing, and retention of my biometric information as described above and detailed in the Biometric notices in our Privacy Policy.';

export const BIOMETRIC_CONSENT_BODY_HTML = `
    <p>
        To confirm your identity and prevent fraud, Evident securely processes
        your government ID and a brief selfie scan. This creates a temporary
        mathematical map of your facial geometry to confirm you are truly you.
    </p> 
    <ul>
        <li>
            <strong>Processor Disclosure:</strong> Data is securely processed by Evident and our
            trusted verification
            <a href="${BIOMETRIC_CONSENT_INCODE_PROVIDERS_URL}" target="_blank" rel="noopener">infrastructure providers</a>.
        </li>
        <li>
            <strong>Data Deletion:</strong> Your biometric data is permanently destroyed as soon
            as your verification is complete, or within 30 days maximum.
        </li>
        <li>
            <strong>Clear Commitments:</strong> Your data is never used to train AI or improve
            our services, and neither we nor our partners sell, lease or trade your personal
            or biometric data.
        </li>
    </ul>
`;

const BIOMETRIC_CONSENT_BODY_TEXT = [
    'To confirm your identity and prevent fraud, Evident securely processes your government ID and a brief selfie scan.',
    'This creates a temporary mathematical map of your facial geometry to confirm you are truly you.',
    '',
    `• Processor Disclosure: Data is securely processed by Evident and our trusted verification infrastructure providers (${BIOMETRIC_CONSENT_INCODE_PROVIDERS_URL}).`,
    '• Data Deletion: Your biometric data is permanently destroyed as soon as your verification is complete, or within 30 days maximum.',
    '• Clear Commitments: Your data is never used to train AI or improve our services, and neither we nor our partners sell, lease or trade your personal or biometric data.',
].join('\n');

// Plain-text checkbox language for the Incode consent relay. Mirrors
// BIOMETRIC_CONSENT_CHECKBOX_LABEL but appends the Privacy Policy URL inline,
// since Incode accepts plain text only and cannot render the hyperlink.
const BIOMETRIC_CONSENT_CHECKBOX_TEXT = `${BIOMETRIC_CONSENT_CHECKBOX_LABEL} (${BIOMETRIC_CONSENT_PRIVACY_POLICY_URL})`;

// Plain-text content for Incode consent relay: body + checkbox language combined.
// Kept separate from BIOMETRIC_CONSENT_BODY_HTML since Incode accepts plain text only.
export const BIOMETRIC_CONSENT_INCODE_CONTENT = `${BIOMETRIC_CONSENT_BODY_TEXT}\n\n${BIOMETRIC_CONSENT_CHECKBOX_TEXT}`;
